import { render, staticRenderFns } from "./LumpAFEPerformanceBudget.vue?vue&type=template&id=84108c68&scoped=true"
import script from "./LumpAFEPerformanceBudget.vue?vue&type=script&lang=ts"
export * from "./LumpAFEPerformanceBudget.vue?vue&type=script&lang=ts"
import style0 from "./LumpAFEPerformanceBudget.vue?vue&type=style&index=0&id=84108c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84108c68",
  null
  
)

export default component.exports